import swiper from '../directives/media/swiper';

/**
 * Logo swiper controls.
 */
export default function logosSection() {

  // Is there a logo swiper?
  const element = document.querySelector('.logos_swiper');
  if (!element) return;

  swiper(element, swiper => {

    // Settings
    let settings = JSON.parse(element.dataset.logosSwiper);
    if (!settings) return;

    // Init
    const slides = element.querySelectorAll('.swiper-slide');
    if (slides.length > 1) {

      const swiperInstance = new swiper(element, settings);
    }
  });
}


// WEBPACK FOOTER //
// ./source/scripts/sections/logos.js